import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yeminus-version',
  templateUrl: './version.component.html'
})
export class VersionComponent implements OnInit {

  private static _instance: VersionComponent;

  public static get Instance(): VersionComponent {
		return this._instance;
	}
  
  public version: string = " 4.0.30.0";
  


  constructor() { 
    VersionComponent._instance = this;
  }

  ngOnInit(): void {
  }

}
